<style lang="less" scoped>
.backtops {
  background: url("../assets/images/top1.png") center center no-repeat #3f51b58a;
  background-size: 15px auto;
  border-radius: 6px;
  width: 28px;
  height: 28px;
  position: fixed;
  right: 10px;
  bottom: 50px;
  z-index: 9999;
  cursor: pointer;
  transition: all 300ms ease;
}
</style>
<template>
  <section>
    <div class="backtops" title="回顶部" />
  </section>
</template>
<script>
import $ from "jquery";
export default {
  data() {
    return {};
  },
  mounted() {
    $(function () {
      $(".backtops").click(function () {
        $("body, html").animate({ scrollTop: 0 }, 800);
      });
      $(window).scroll(function () {
        if ($(this).scrollTop() > 180) {
          $(".backtops").fadeIn(200);
        } else {
          $(".backtops").fadeOut(200);
        }
      });
    });
  },
  methods: {},
};
</script>